"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var yaml_ast_parser_1 = require("@stoplight/yaml-ast-parser");

exports.Kind = yaml_ast_parser_1.Kind;
exports.ScalarType = yaml_ast_parser_1.ScalarType;